// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--BbjjQ","title":"a10a3f92e9--title--Qx3Fz","text":"a10a3f92e9--text--Rq8Hg"};